import * as paymentActions from "@rentiohq/shared-frontend/dist/redux/payment/payment.actions";
import * as paymentSelectors from "@rentiohq/shared-frontend/dist/redux/payment/payment.selectors";
import { IContract } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootStore } from "redux/reducers";
import StatusDot from "../StatusDot";
import { EStatus } from "../StatusDot/StatusDot.types";

interface IProps {
  contract: IContract;
}

const StatusDotOutstandingContractPaymentOrders = (props: IProps) => {
  const { contract } = props;

  // Helpers
  const paymentOrdersIdentifier = `contract-${contract.id}`;

  // Redux
  const dispatch = useDispatch();
  const paymentOrders = useSelector((state: IRootStore) =>
    paymentSelectors.getPaymentOrdersByIdentifier(
      state,
      paymentOrdersIdentifier,
    ),
  );

  const isFetching = useSelector((state: IRootStore) =>
    paymentSelectors.isFetchingPaymentOrdersByIdentifier(
      state,
      paymentOrdersIdentifier,
    ),
  );

  // Lifecycle
  React.useEffect(() => {
    if (contract.manuallyCompletedEndPaymentRent) {
      return;
    }

    if (isFetching) {
      return;
    }

    // if (getStatus() === EStatus.Success) {
    //   return;
    // }

    dispatch(
      paymentActions.getPaymentOrdersByIdentifier.actions.start({
        paymentOrdersIdentifier,
        refetch: true,
        filterData: {
          where: { contractId: contract.id, completedAt: null },
        },
      }),
    );
  }, [contract]);

  // Helpers
  const getStatus = () => {
    if (contract.manuallyCompletedEndPaymentRent) {
      return EStatus.Success;
    }

    if (!paymentOrders || paymentOrders.length === 0) {
      return EStatus.Success;
    }

    return EStatus.Error;
  };

  // Render
  const renderTooltipContent = () => {
    if (contract.manuallyCompletedEndPaymentRent) {
      return getLocalizedText(contract.manuallyCompletedEndPaymentRent);
    }

    if (!paymentOrders || paymentOrders.length === 0) {
      return getLocalizedText("status.outstanding_payments.empty");
    }

    return getLocalizedText("status.outstanding_payments.open_payments");
  };

  return (
    <StatusDot status={getStatus()} tooltipContent={renderTooltipContent()} />
  );
};

// eslint-disable-next-line import/no-default-export
export default StatusDotOutstandingContractPaymentOrders;
